import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// ICON Import
import ICONS from "../../assets/Icons";

// REDUX Imports
import {
  setMultipleEntity,
  setShowReloginModalFalse,
} from "../../redux/features/login/login";
import { verifyOtpEmail, verifyOtpMob } from "../../redux/features/users";
import {
  AddUserTag,
  assignRole,
  getSpecificUser,
  getUsers,
  removeRole,
  RemoveUserTag,
} from "../../redux/features/Settings/Management/Users";
import { beneVerifyThisPAN } from "../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  xpentraLogout,
  xpentraLogoutSliceReset,
} from "../../redux/features/logout/logout";
import { logout } from "../../redux/features/refreshToken/refreshToken";
import { getUserDetailsStateAction } from "../../redux/features/users/userDetails";

// UTLIS Imports
import formatDateViewAll from "../../utils/formatDateViewAll";
import {
  GlobalConfiguration,
  SettingsStatisticsConfiguration,
} from "../../utils/configurationProvider";

// COMPONENTS Imports
import FullScreen from "../../components/FullScreen";
import GeoMapLeaflet from "../../components/_utils/GeoMapLeaflet";
import Loader from "../../components/Loader/Index";
import PanVerification from "../Settings/PanVerification";
import SVGComponent from "../../components/_utils/SVGComponent";
import TitleSubtitlePair from "../../components/_utils/TitleSubtitlePair";
import TopNavSmallButton from "../../components/_utils/CommonButtons/TopNavSmallButton";
import SwitcherTabs from "../../components/_utils/CommonButtons/SwitcherTabs";
import CommonDetailCard from "../../components/_utils/CommonDetailCard";
import CommonContainerCard from "../../components/_utils/CommonContainerCard";
import Chips from "../../components/_utils/CommonButtons/Chips";
import SmallPopup from "../../components/_utils/CommonSmallPopup";
import LargePopupRedirect from "../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import EditCommonPopup from "../../components/_utils/CommonPopups/CommonEditPopup";
import SmallPopupWithInput from "../../components/_utils/CommonSmallPopupWithInput";
import useServiceChecker from "../../components/ServiceChecker";
import CommonAssignTagPopup from "../../components/_utils/CommonPopups/CommonAssignTagPoppup";
import CommonToast from "../../components/_utils/CommonToast";

function MyProfileDetails(payload) {
  // useDispatch
  const dispatch = useDispatch();

  // useNavigate
  const navigate = useNavigate();

  const [ensureAll] = useServiceChecker();

  // useState
  const [ownerDetailData, setOwnerdetaildata] = useState([]);
  const [initialRoles, setInitialRoles] = useState([]);
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [showPanPopup, setPanShowPopup] = useState(false);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [newTags, setNewTags] = useState([]);
  const [existingTags, setExistingTags] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("User details");
  const [selectedChipIndex, setSelectedChipIndex] = useState(null);
  const [showAssignRolesPopup, setShowAssignRolesPopup] = useState(false);
  const [verifyContactNoModal, SetVerifyContactNoModal] = useState(false);
  const [verifyEmailIdModal, setVerifyEmailIdModal] = useState(false);
  const [contactInputText, setContactInputText] = useState("");
  console.log(contactInputText);
  const [emailInputText, setEmailInputText] = useState("");
  console.log(emailInputText);
  const [newRoles, setNewRoles] = useState([]);
  const [AllRoles, setAllRoles] = useState([]);
  const [AllTags, setAllTags] = useState([]);
  const loginid = JSON.parse(sessionStorage.getItem("response"));
  const [tagModal, setTagModal] = useState(false);
  const [existingRole, setExistingRole] = useState([]);

  // useSelector
  const { removeUserTagsLoading } = useSelector((state) => state.users);
  const { specificUserData, specificUserLoading } = useSelector(
    (state) => state?.users,
  );
  const getUserDetailsState = useSelector((state) => state?.getUserDetailsinfo);
  const refreshData = useSelector((state) => state.refreshToken.data);
  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const id = refreshData?.employees?.id;

  const mobno =
    specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]?.mob_no;
  const email =
    specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]
      ?.email_id;

  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
    });
  };
  const isAdmin = ensureAll(["Admin"]).status;

  const handleEdit = () => {
    setIsEditModalOpen(true);
  };
  const openLogout = () => {
    setOpenLogoutModal(true);
  };

  const closeLogout = () => {
    setOpenLogoutModal(false);
  };
  const handlePANDetails = async (pan) => {
    if (pan?.length === GlobalConfiguration.panLength) {
      const response = await dispatch(
        beneVerifyThisPAN({ search_string: pan }),
      );
      if (response?.payload?.status === true) {
        setPanShowPopup(true);
      } else if (
        response?.payload?.errors?.user_unauthorized?.[
          GlobalConfiguration.lengthCheckZero
        ]
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "BUAccount",
          },
        });
      } else if (response?.payload?.status === false) {
        CommonToast({
          text: response?.payload?.errors?.base[
            GlobalConfiguration.lengthCheckZero
          ],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }
  };

  const handleTabClick = (tabKey) => {
    setSelectedTab(tabKey);
  };
  const handleLogout = async () => {
    try {
      const res = await dispatch(xpentraLogout()).unwrap();

      if (res?.status) {
        dispatch(setMultipleEntity());
        dispatch(setShowReloginModalFalse());
        dispatch(logout());
        dispatch(xpentraLogoutSliceReset());
        navigate("/login");
        sessionStorage.clear();
      } else {
      }
    } catch (err) {
    } finally {
      setOpenLogoutModal(false);
    }
  };

  const servicesMap = specificUserData?.user_services?.reduce((acc, curr) => {
    if (!acc[curr?.service_header]) {
      acc[curr.service_header] = [];
    }
    acc[curr.service_header].push({
      service_id: curr.service_id,
      service_name: curr.service_name,
      service_desc: curr.service_desc,
    });
    return acc;
  }, {});

  const featuresMap = specificUserData?.user_features?.reduce((acc, curr) => {
    const desc = curr?.feature_description;
    if (!acc[desc]) {
      acc[desc] = [];
    }
    acc[desc].push({
      feature_id: curr.feature_id,
      feature_name: curr.feature_name,
      feature_description: curr.feature_description,
    });
    return acc;
  }, {});

  const rolesMap = specificUserData?.user_roles?.reduce((acc, curr) => {
    if (!acc[curr?.role_desc]) {
      acc[curr?.role_desc] = [];
    }
    acc[curr?.role_desc].push(curr?.role_name);

    return acc;
  }, {});

  const ArrowLeft = ICONS.ARROW_LEFT_WHITE;

  const tabs = [
    {
      label: "Details",
      key: "User details",
      handler: () => handleTabClick("User details"),
    },
    {
      label: "CIN details",
      key: "CIN details",
      handler: () => handleTabClick("CIN details"),
    },
    {
      label: "DIN details",
      key: "DIN details",
      handler: () => handleTabClick("DIN details"),
    },
    { label: "Roles", key: "Roles", handler: () => handleTabClick("Roles") },
    {
      label: "Features",
      key: "Features",
      handler: () => handleTabClick("Features"),
    },
    {
      label: "Services",
      key: "Services",
      handler: () => handleTabClick("Services"),
    },
    {
      label: "Tags",
      key: "Assigned Tags",
      handler: () => handleTabClick("Assigned Tags"),
    },
  ];

  const EditCircleIcon =
    "https://q2pay.in/new_assets/common/detail_page/edit_with_white_circle.svg";
  const Logout = "https://q2pay.in/new_assets/common/settings/logout.svg";
  const AuthorizedDevicesIcon =
    "https://q2pay.in/new_assets/common/settings/authorized_devices_with_white_circle.svg";
  const ChangePassword =
    "https://q2pay.in/new_assets/common/settings/change_password_with_white_circle.svg";
  function handleChipClick(id) {
    setSelectedChipIndex(id);
  }
  const chipsArray = [
    {
      text: "Name, Contact details, Alias",
      selected: selectedChipIndex == GlobalConfiguration.lengthCheckOne,
      disabled: false,
      bulletPoint: ["Require approval."],
      hoverOption: "white",
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckOne),
    },
    {
      text: "Roles",
      selected:
        selectedChipIndex ==
        SettingsStatisticsConfiguration.strokeWidthForLineGraph,
      disabled: !isAdmin,
      bulletPoint: ["Require approval."],
      hoverOption: "white",
      onClick: () =>
        handleChipClick(
          SettingsStatisticsConfiguration.strokeWidthForLineGraph,
        ),
    },
  ];

  const handleModalClose = () => {
    setIsEditModalOpen(false);
    setSelectedChipIndex(null);
  };
  const handleApply = () => {
    switch (selectedChipIndex) {
      case 1:
        navigate(`/settings/my_profile/contact_details/${id}`);
        break;

      case 2:
        setShowAssignRolesPopup(true);
        setIsEditModalOpen(false);
        break;

      default:
        break;
    }
  };

  const handleVerificationNumber = () => {
    dispatch(verifyOtpMob({ mob_no: mobno, passcode: contactInputText }));
    SetVerifyContactNoModal(false);
  };

  const handleEmailVerification = () => {
    dispatch(verifyOtpEmail({ email: email, passcode: emailInputText }));
    setVerifyEmailIdModal(false);
  };

  let userDetailsData =
    specificUserData?.status === true
      ? specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]
      : getUserDetailsState?.status &&
          id ===
            getUserDetailsState?.userInfo?.[GlobalConfiguration.lengthCheckZero]
              ?.id
        ? getUserDetailsState?.userInfo?.[GlobalConfiguration.lengthCheckZero]
        : undefined;

  // useEffect
  useEffect(() => {
    if (id) {
      dispatch(getSpecificUser(id));
    }
  }, [dispatch, id]);
  useEffect(() => {
    if (!specificUserData) return;
    const assigned =
      specificUserData.user_roles?.map((r) => ({
        role_id: r.role_id,
        value: r.role_name,
        role_desc: r.role_desc,
        selected: true,
        type: "ownerTags",
      })) || [];

    const unassigned =
      specificUserData.unassigned_user_roles?.map((r) => ({
        role_id: r.role_id,
        value: r.role_name,
        role_desc: r.role_desc,
        selected: true,
        type: "Available",
      })) || [];

    if (!showAssignRolesPopup) {
      setNewRoles(assigned);
      setInitialRoles(assigned);
      setAllRoles(unassigned);
    }
  }, [specificUserData, showAssignRolesPopup]);
  useEffect(() => {
    if (!specificUserLoading && specificUserData) {
      let checkUserId =
        getUserDetailsState?.userInfo?.[GlobalConfiguration.lengthCheckZero]
          ?.id;

      if (
        userDetailsData === undefined &&
        id !== checkUserId &&
        getUserDetailsState?.status
      ) {
        navigate("*");
      } else if (
        specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]
          ?.account_tags
      ) {
        const data = specificUserData?.employees?.[
          GlobalConfiguration.lengthCheckZero
        ]?.account_tags?.map((res) => {
          return { selected: true, value: res, type: "ownerTags" };
        });

        setNewTags(data);
      }
    }
  }, [
    userDetailsData,
    specificUserData,
    getUserDetailsState,
    specificUserLoading,
    id,
    navigate,
  ]);
  useEffect(() => {
    if (
      loginid?.employees?.id !== id &&
      !services?.includes("Admin") &&
      specificUserLoading === false &&
      isLoading === false
    ) {
      navigate("/feature_not_assigned", {
        replace: true,
        state: {
          unavailableService: "VSpecificEmp",
        },
      });
    }
  }, [
    id,
    isLoading,
    loginid?.employees?.id,
    navigate,
    services,
    specificUserData,
    specificUserLoading,
  ]);
  useEffect(() => {
    handleuserAll();
  }, []);
  useEffect(() => {
    let getUserDetailsStateStorage = JSON.parse(
      sessionStorage.getItem("userDetailsInfostorage"),
    );

    dispatch(getUserDetailsStateAction(getUserDetailsStateStorage));
  }, [dispatch]);

  const normalizeSearchValue = (text = "") =>
    text.toString().toLowerCase().replace(/[_-]+/g, "").replace(/\s+/g, "");
  const handleCloseAssignRoles = async () => {
    setShowAssignRolesPopup(false);
    setSelectedChipIndex(null);

    try {
      await dispatch(getSpecificUser(id)).unwrap();
    } catch (err) {
      console.error("Refresh after popup close failed:", err);
    }
  };
  const handleAddNewRoles = async (rolesFromPopup) => {
    CommonToast({
      text: "Assigning role",
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
    });

    await dispatch(
      assignRole({
        id,
        newRoles: rolesFromPopup.map((r) => ({ role_id: r.role_id })),
      }),
    ).unwrap();
    toast.dismiss();
    CommonToast({
      text: "Role assigned successfully.",
      icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
      variant: "var(--success)",
      buttonNeeded: false,
    });

    await dispatch(getSpecificUser(id)).unwrap();

    const addedRoles = rolesFromPopup.map((r) => {
      const original = AllRoles.find((a) => a.role_id === r.role_id);
      return {
        role_id: r.role_id,
        value: original ? original.value : r.value,
        role_desc: original ? original.role_desc : r.role_desc,
        selected: true,
        type: "ownerTags",
      };
    });

    setNewRoles((prev) => [...prev, ...addedRoles]);

    setAllRoles((prev) =>
      prev.filter(
        (r) => !rolesFromPopup.some((added) => added.role_id === r.role_id),
      ),
    );
  };

  const handleRemoveRoles = async (rolePayloadFromPopup) => {
    CommonToast({
      text: "unassigning role",
      icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
      variant: "var(--processing)",
      buttonNeeded: false,
    });
    const incomingIds =
      (rolePayloadFromPopup || [])
        .map((it) => (it && it.role_id ? it.role_id : null))
        .filter(Boolean) || [];

    let rolesToRemove = [];

    if (incomingIds.length > GlobalConfiguration.lengthCheckZero) {
      rolesToRemove = newRoles.filter((r) => incomingIds.includes(r.role_id));
    } else {
      const normalizedIncoming = (rolePayloadFromPopup || []).map((n) =>
        normalizeSearchValue(n),
      );
      rolesToRemove = newRoles.filter((r) =>
        normalizedIncoming.includes(normalizeSearchValue(r.value)),
      );
    }

    for (const role of rolesToRemove) {
      try {
        await dispatch(
          removeRole({
            id,
            role_id: role.role_id,
          }),
        ).unwrap();
        toast.dismiss();
        CommonToast({
          text: "Role unassigned successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          buttonNeeded: false,
        });
      } catch (err) {
        console.error("removeRole failed for", role.role_id, err);
      }
    }

    await dispatch(getSpecificUser(id)).unwrap();

    const removedIds = rolesToRemove.map((r) => r.role_id);

    setNewRoles((prev) => prev.filter((r) => !removedIds.includes(r.role_id)));

    setAllRoles((prev) => [
      ...prev,
      ...rolesToRemove.map((r) => ({
        ...r,
        selected: true,
        type: "Available",
      })),
    ]);
  };

  const getOwnerDetaildata = async () => {
    setLoading(true);
    try {
      const response = await dispatch(getSpecificUser(id));

      setOwnerdetaildata(
        response?.payload?.employees?.[GlobalConfiguration.lengthCheckZero],
      );

      if (
        response?.payload?.employees?.[GlobalConfiguration.lengthCheckZero]
          ?.tags &&
        response?.payload?.employees?.[GlobalConfiguration.lengthCheckZero]
          ?.tags.length > GlobalConfiguration.lengthCheckZero
      ) {
        const data = response?.payload?.employees?.[
          GlobalConfiguration.lengthCheckZero
        ].tags?.map((res) => {
          return { selected: true, value: res, type: "ownerTags" };
        });

        setNewTags(data);
        setLoading(true);
      }

      setLoading(false);
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }

      if (response?.payload === undefined) {
        navigate("/feature_not_assigned");
      } else {
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const rolesDes = {
    searchPlaceholderDescription: "Search by role name",
    headerDescription: "The user’s role within the entity.",
    title3: `Select roles and click "Assign" to link them to the user. `,
    title4: `Select roles and click "Unassign" to unlink them from the user.`,
    title5: "Roles selected",
    title7: "No assigned roles found.",
    title8: "No unassigned roles found.",
    title1: "Assigned roles",
    title2: "Unassigned roles",
    title6: " ",
    zeroValueDescription: `To assign roles, select from the list of unassigned roles and click "Assign"`,
  };

  const toTitleCase = (text) => {
    if (!text) return "";

    return text
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleTagPopupOpen = () => {
    setTagModal(true);
  };

  const handleCloseTagModal = () => {
    setTagModal(false);
  };

  const handleuserAll = async () => {
    setLoading(true);

    try {
      let response = await dispatch(
        getUsers({
          page_no: GlobalConfiguration.lengthCheckOne,
          page_size: GlobalConfiguration.searchMaxLength,
        }),
      );
      if (response?.payload?.status === true) {
        const data = response?.payload?.available_tags?.map((res) => {
          return { selected: true, value: res, type: "Available" };
        });

        setAllTags(data);
        setLoading(false);
      } else {
        setLoading(false);
        CommonToast({
          text: response?.payload?.message,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleAddTags = async (item) => {
    try {
      setLoading(true);

      let response = await dispatch(
        AddUserTag({
          user_id: [id],
          tags:
            item?.type === "newAss" ? item?.data1 : item?.map((i) => i.value),
        }),
      );

      if (response?.payload?.status === true) {
        getOwnerDetaildata();
        setNewTags((prev) => [...prev, response?.meta?.arg?.tags]);
        handleuserAll();
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const handleRemoveTags = async (item) => {
    if (removeUserTagsLoading) {
      setLoading(true);
    }

    try {
      setLoading(true);
      const response = await dispatch(
        RemoveUserTag({ user_id: [id], tags: item }),
      );

      if (response?.payload?.status === true) {
        getOwnerDetaildata();
        setNewTags((prevTags) => prevTags.filter((tag) => tag?.value !== item));
        handleuserAll();
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error removing tag:", error);
    }
  };
  const tagsDes = {
    searchPlaceholderDescription: "Search by tag",
    title7: "No assigned tags found.",
    title8: "No unassigned tags found.",
    title5: "Tag selected",
    title1: "Assigned tags",
    title2: "Unassigned tags",
  };

  return (
    <>
      {showAssignRolesPopup && (
        <div className="fixed top-top-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <CommonAssignTagPopup
            headerTitle="Assign/Unassign roles:"
            closehandleFunction={handleCloseAssignRoles}
            closedisabledBgColor=""
            closebuttonRef=""
            closeimgColor=""
            loading={loading}
            setLoading={setLoading}
            newTags={newRoles}
            AllTags={AllRoles}
            handleAddTags={handleAddNewRoles}
            existingTags={existingRole}
            setExistingTags={setExistingRole}
            handleRemoveTags={handleRemoveRoles}
            setNewTags={(arr) => {
              const mapped = arr.map((a) => {
                const original =
                  newRoles.find((nr) => nr.role_id === a.role_id) ||
                  AllRoles.find((ar) => ar.role_id === a.role_id);
                return original ? { ...original, selected: a.selected } : a;
              });
              setNewRoles(mapped);
            }}
            ownerExistingTag={[]}
            setAllTags={(arr) => {
              const mapped = arr.map((a) => {
                const original =
                  AllRoles.find((ar) => ar.role_id === a.role_id) ||
                  newRoles.find((nr) => nr.role_id === a.role_id);
                return original ? { ...original, selected: a.selected } : a;
              });
              setAllRoles(mapped);
            }}
            getOwnerDetaildata={getOwnerDetaildata}
            ownerDetailData={[]}
            dummyUser={true}
            type={"ownerDetails"}
            users={true}
            isCapitalWords={true}
            typeForSpaces={"privateTxn"}
            description={rolesDes}
          />
        </div>
      )}
      {tagModal && (
        <div className="fixed top-top-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <CommonAssignTagPopup
            headerTitle="Assign/Unassign tags:"
            closehandleFunction={handleCloseTagModal}
            closedisabledBgColor=""
            closebuttonRef=""
            closeimgColor=""
            newTags={newTags}
            handleAddTags={handleAddTags}
            existingTags={existingTags}
            setExistingTags={setExistingTags}
            handleRemoveTags={handleRemoveTags}
            setNewTags={setNewTags}
            ownerExistingTag={[]}
            AllTags={AllTags}
            setAllTags={setAllTags}
            loading={loading}
            setLoading={setLoading}
            getOwnerDetaildata={getOwnerDetaildata}
            ownerDetailData={[]}
            dummyUser={true}
            type={"ownerDetails"}
            users={[
              specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]
                ?.first_name,
            ]}
            description={tagsDes}
          />
        </div>
      )}
      {verifyContactNoModal && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal Qmd:bg-PopUp-BackDrop !bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Verify contact number"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Verification code has been sent to your registered mobile number. Please enter the 6 digit code to complete the verification"
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-primary"
            secondHeaderTextSize="font-sm"
            inputPlaceholder="6 digit code"
            inputVariant="default"
            isTextInputField
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              if (value.length <= 6) {
                setContactInputText(value);
              }
            }}
            inputValue={contactInputText}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText="Clear"
            btnOneHandleFunction={() => SetVerifyContactNoModal(false)}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Verify"
            btnTwoHandleFunction={handleVerificationNumber}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !contactInputText ||
              contactInputText.length < GlobalConfiguration.otpLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded
          />
        </div>
      )}
      {verifyEmailIdModal && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal Qmd:bg-PopUp-BackDrop !bg-opacity-dark-opacity">
          <SmallPopupWithInput
            headerTitle="Verify email"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Verification code has been sent to your registered email ID. Please enter the 6 digit code to complete the verification"
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-primary"
            secondHeaderTextSize="font-sm"
            inputPlaceholder="6 digit code"
            inputVariant="default"
            isTextInputField
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              const value = e.target.value.replace(/\D/g, "");
              if (value.length <= GlobalConfiguration.otpLength) {
                setEmailInputText(value);
              }
            }}
            inputValue={emailInputText}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText="Clear"
            btnOneHandleFunction={() => setVerifyEmailIdModal(false)}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Verify"
            btnTwoHandleFunction={handleEmailVerification}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !emailInputText ||
              emailInputText.length < GlobalConfiguration.otpLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
            btnTwoInActiveVariantNeeded
          />
        </div>
      )}
      {showPanPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="PAN Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(`/settings/PAN_verification`, {
                state: specificUserData?.pan_details?.pan,
              })
            }
            closeiconhandleFunction={() => setPanShowPopup(false)}
          >
            <PanVerification
              pan_no={specificUserData?.pan_details?.pan}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}

      {alertPopUp && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <FullScreen
            id={payload?.bene_account_id}
            setAlertPopUp={setAlertPopUp}
          />
        </div>
      )}

      <div
        className="flex flex-col h-screen overflow-auto"
        style={{
          height: "var(--full-height)",
          overflowX: "hidden",
          overflowY: openLogoutModal || isEditModalOpen ? "hidden" : "auto",
        }}
      >
        {openLogoutModal && (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop !bg-opacity-dark-opacity">
            <SmallPopup
              headerTitle="Logout?"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              subtext="Are you sure you want to logout?"
              btnOneText="Cancel"
              btnOneBtnType="button"
              btnOneEnabledBgColor="transparent"
              btnOneHandleFunction={() => closeLogout()}
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Confirm"
              btnTwoBtnType="button"
              btnTwoEnabledBgColor="var(--positive-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoHoverOption="black"
              btnTwoHandleFunction={() => handleLogout()}
            />
          </div>
        )}
        <div className="h-auto">
          {isEditModalOpen && (
            <div className="fixed top-top-base left-left-base z-max-zindex w-screen h-screen bg-PopUp-BackDrop bg-opacity-dark-opacity overflow-hidden">
              <EditCommonPopup
                headerTitle="Select the option you would like to edit:"
                chipsArray={chipsArray}
                btnOneText="Cancel"
                btnOneEnabledBgColor="var(--primary-bg)"
                btnOneEnabledTextColor="var(--text-primary)"
                btnOneHoverOption="white"
                btnOneOutLineColor="var(--text-primary)"
                btnTwoText="Edit"
                btnTwoEnabledBgColor="var(--text-primary)"
                btnTwoEnabledTextColor="var(--primary-bg)"
                btnTwoDisabledBgColor="var(--text-disabled)"
                btnTwoHoverOption="black"
                btnOneHandleFunction={handleModalClose}
                btnTwoInActiveVariantNeeded={true}
                btnTwoHandleFunction={handleApply}
                btnTwoDisabledTextColor="var(--text-primary)"
                btnTwoIsDisabled={selectedChipIndex === null}
              />
            </div>
          )}
        </div>

        {!specificUserData ? (
          <div className="flex justify-center items-center h-screen">
            <Loader />
          </div>
        ) : (
          <>
            <div className="bg-primary-nav">
              <div className="lg:h-navbar-breadcrumb-height h-height-base"></div>
            </div>
            <div className="w-width-full">
              <div
                className="lg:hidden fixed w-width-full top-top-base bg-primary-card flex items-center cursor-pointer py-padding-xs"
                style={{ zIndex: "var(--z-index-header)" }}
              >
                <div
                  onClick={() => navigate(GlobalConfiguration.navigate_back)}
                >
                  <div className="m-margin-sm">
                    <SVGComponent
                      url={ArrowLeft}
                      color="var(--text-primary)"
                      width="var(--icon-sm)"
                      height="vyar(--icon-sm)"
                    />
                  </div>
                </div>
                <h1 className="text-font-md flex-1 text-text-primary ml-margin-sm">
                  My profile
                </h1>
              </div>
              <div className="bg-primary-nav w-width-full">
                <div className="max-w-tab-width-normal mx-auto text-text-primary px-padding-md lg:px-padding-base">
                  <div className="flex flex-wrap mt-margin-xl Qmd:mt-margin-base pt-padding-xs Qmd:pt-padding-base">
                    <div className="block lg:hidden w-full">
                      <div className="Qmd:h-[calc(var(--navbar-breadcrumb-height)-var(--navbar-height))] "></div>
                      <div className="Qmd:h-navbar-height"></div>
                    </div>
                    <div className="flex w-full">
                      <div className="w-full lg:w-width-full flex flex-col lg:flex-row flex-wrap lg:mt-margin-base">
                        <div className="flex-1 lg:pl-padding-sm pr-padding-md lg:pr-padding-md py-padding-sm lg:py-padding-base lg:my-margin-md flex items-center border-b lg:border-b-0 border-r-0 lg:border-r border-primary-bg pl-padding-base  ">
                          <div className="w-full">
                            <TitleSubtitlePair
                              title={`${specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]?.first_name} ${
                                specificUserData?.employees?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.last_name
                              }`
                                ?.toLowerCase()
                                ?.replace(/^\w/, (c) => c.toUpperCase())}
                              subtitle="Username"
                              titleColor="text-primary"
                              variant="md"
                            />
                          </div>
                        </div>

                        <div className="flex-1 px-padding-md py-padding-sm lg:py-padding-base lg:my-margin-md flex items-center border-b lg:border-b-border-base border-r-border-base lg:border-r border-primary-bg pl-padding-base lg:pl-padding-md">
                          <div className="w-full">
                            <TitleSubtitlePair
                              title={
                                specificUserData?.employees?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.user_id
                              }
                              subtitle="User ID"
                              titleColor="text-primary"
                              variant="md"
                            />
                          </div>
                        </div>

                        <div className="flex-1 px-padding-md py-padding-sm lg:py-padding-base lg:my-margin-md flex items-center pl-padding-base lg:pl-padding-md">
                          <div className="w-full">
                            <TitleSubtitlePair
                              title={
                                specificUserData?.employees?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.alias_name || "Not Given"
                              }
                              titleColor="text-primary"
                              subtitle="Alias"
                              variant="md"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="w-full lg:w-[fit-content] hidden lg:flex">
                        <TopNavSmallButton
                          btnText={
                            <>
                              Edit <br /> profile
                            </>
                          }
                          enabledBgColor="var(--primary-nav-act)"
                          icon={EditCircleIcon}
                          handleFunction={handleEdit}
                          enabledTextColor="var(--text-primary)"
                          hoverOption="white"
                        />
                      </div>
                    </div>
                    <div className="border-primary-bg border-t-border flex w-full"></div>

                    <div className="flex w-full">
                      <div className="w-full lg:w-width-full flex flex-col lg:flex-row flex-wrap">
                        <div className="flex-1  lg:pl-padding-sm pr-padding-md lg:pr-padding-md py-padding-sm lg:py-padding-base lg:my-margin-md flex items-center border-b lg:border-b-0 border-r-0 lg:border-r border-primary-bg pl-padding-base ">
                          <div className="w-full">
                            <TitleSubtitlePair
                              title={`+91 ${specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]?.mob_no}`}
                              // subtitle={`Contact number ${specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]?.verified_sms == "Y" ? "- Verified" : "- Not verified"}`}
                              subtitle="Contact number"
                              titleColor="text-primary"
                              variant="md"
                              // subtitleIcon={`${specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]?.verified_sms == "Y" ? ICONS.SELECTED_WITH_GREEN_CIRCLE : false}`}
                            />
                          </div>
                          {/* {specificUserData?.employees?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.verified_sms != "Y" ? (
                            <div>
                              <PrimaryWithIconButton
                                btnText="Verify"
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-card)"
                                icon={ICONS.ALERT}
                                handleFunction={handleOpenVerifyNumber}
                              />
                            </div>
                          ) : null} */}
                        </div>
                        <div className="flex-1 px-padding-md py-padding-sm lg:py-padding-base lg:my-margin-md flex items-center pl-padding-base lg:pl-padding-md ">
                          <div className="w-full">
                            <TitleSubtitlePair
                              title={
                                specificUserData?.employees?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.email_id
                              }
                              // subtitle={`Email ID ${specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]?.verified_email == "Y" ? "- Verified" : "- Not verified"}`}
                              subtitle="Email ID"
                              titleColor="text-primary"
                              variant="md"
                              // subtitleIcon={`${specificUserData?.employees?.[GlobalConfiguration.lengthCheckZero]?.verified_email == "Y" ? ICONS.SELECTED_WITH_GREEN_CIRCLE : false}`}
                            />
                          </div>
                          {/* {specificUserData?.employees?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.verified_email != "Y" ? (
                            <div>
                              <PrimaryWithIconButton
                                btnText="Verify"
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-card)"
                                icon={ICONS.ALERT}
                                handleFunction={handleOpenVerifyEmail}
                              />
                            </div>
                          ) : null} */}
                        </div>
                        <div className="flex-1 px-padding-md my-margin-md lg:flex hidden items-center invisible "></div>
                      </div>

                      <div className="w-full lg:w-[fit-content] hidden lg:flex">
                        <TopNavSmallButton
                          btnText={
                            <>
                              Change <br /> password
                            </>
                          }
                          icon={ChangePassword}
                          handleFunction={() => {
                            if (
                              services?.includes("CPwd") ||
                              services?.includes("Admin")
                            ) {
                              navigate("/settings/my_profile/change_password");
                            } else {
                              navigate("/feature_not_assigned", {
                                state: { unavailableService: "CPwd" },
                              });
                            }
                          }}
                          enabledBgColor={"var(--primary-nav-act)"}
                          isDisabled={
                            !(
                              services?.includes("CPwd") ||
                              services?.includes("Admin")
                            )
                          }
                          hoverOption="white"
                          btnType="button"
                        />
                      </div>
                    </div>
                    <div className="border-primary-bg border-t-border flex w-full"></div>

                    <div className="flex w-full justify-between  border-primary-bg">
                      <div className="w-full Qlg:w-tl-width-3 flex flex-col lg:flex-row flex-wrap">
                        <div className="flex-1  Qlg:pl-padding-sm pr-padding-md lg:pr-padding-md py-padding-sm lg:py-padding-base lg:my-margin-md flex items-center border-b lg:border-b-border-base border-r-boborder-b-border-base lg:border-r border-primary-bg px-padding-base ">
                          <div className="w-full">
                            <TitleSubtitlePair
                              isBold
                              title={
                                specificUserData?.employees?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.active_status === "Y"
                                  ? "Active"
                                  : "Not Active"
                              }
                              subtitle="Status"
                              titleColor="settled"
                              variant="md"
                            />
                          </div>
                        </div>
                        <div className="flex-1 px-padding-md py-padding-sm lg:py-padding-base lg:my-margin-md flex items-center pl-padding-base lg:px-padding-md">
                          <div className="w-full">
                            <TitleSubtitlePair
                              title={
                                specificUserData?.employees?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.grade
                              }
                              subtitle=" Grade"
                              titleColor="text-primary"
                              variant="md"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="w-full lg:w-[fit-content] hidden lg:flex bg-primary-nav-act">
                        <TopNavSmallButton
                          btnText={
                            <>
                              Authorizied <br /> devices
                            </>
                          }
                          icon="https://q2pay.in/new_assets/common/settings/authorized_devices_with_white_circle.svg"
                          handleFunction={() => {
                            if (services?.includes("Sup_VDevice")) {
                              navigate("/settings/devices_view_all");
                            } else {
                              navigate("/feature_not_assigned", {
                                state: { unavailableService: "Sup_VDevice" },
                              });
                            }
                          }}
                          isDisabled={!services?.includes("Sup_VDevice")}
                          hoverOption="white"
                          btnType="button"
                        />
                        <div className="border-primary-bg border-r-border my-margin-button-l"></div>

                        <TopNavSmallButton
                          btnText={
                            <>
                              Logout <br />
                              {""}
                            </>
                          }
                          icon={Logout}
                          handleFunction={openLogout}
                          enabledBgColor="var(--primary-nav-act)"
                          enabledTextColor="var(--text-secondary)"
                          hoverOption="white"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="block lg:hidden mt-margin-md">
                <p className="bg-primary-card py-padding-sm text-font-sm font-semibold text-text-secondary pl-padding-sm flex items-center">
                  Quick Actions
                </p>

                <div className="w-width-full flex flex-wrap border-t border-primary-bg text-text-primary">
                  <div className="w-width-md border-b border-r border-primary-bg flex justify-center items-center">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Edit <br /> profile
                        </>
                      }
                      handleFunction={handleEdit}
                      icon={EditCircleIcon}
                      btnType="button"
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav)"
                      hoverOption="white"
                      fullWidthRequired
                    />
                  </div>
                  <div className="w-width-md border-b border-primary-bg flex justify-center items-center">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Logout <br />
                          {""}
                        </>
                      }
                      handleFunction={openLogout}
                      icon={Logout}
                      btnType="button"
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav)"
                      hoverOption="white"
                      fullWidthRequired
                    />
                  </div>
                  <div className="w-width-md border-r border-primary-bg flex justify-center items-center">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Authorizied <br /> devices
                        </>
                      }
                      handleFunction={() => {
                        if (services?.includes("Sup_VDevice")) {
                          navigate("/settings/devices_view_all");
                        } else {
                          navigate("/feature_not_assigned", {
                            state: { unavailableService: "Sup_VDevice" },
                          });
                        }
                      }}
                      icon={AuthorizedDevicesIcon}
                      btnType="button"
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav)"
                      hoverOption="white"
                      fullWidthRequired
                      isDisabled={!services?.includes("Sup_VDevice")}
                    />
                  </div>
                  <div className="w-width-md flex justify-center items-center">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Change <br /> password
                        </>
                      }
                      handleFunction={() => {
                        if (
                          services?.includes("CPwd") ||
                          services?.includes("Admin")
                        ) {
                          navigate("/settings/my_profile/change_password");
                        } else {
                          navigate("/feature_not_assigned", {
                            state: { unavailableService: "CPwd" },
                          });
                        }
                      }}
                      icon={ChangePassword}
                      btnType="button"
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav)"
                      hoverOption="white"
                      fullWidthRequired
                    />
                  </div>
                </div>
              </div>

              <div className="w-width-full max-w-tab-width-normal flex-grow mx-auto my-margin-md">
                <div className="bg-primary-bg">
                  <div className="px-padding-md Qsmd:px-padding-base mb-margin-md relative z-z-index-base">
                    <div className="overflow-x-scroll no-scrollbar rounded-border-radius-md">
                      <div className="inline-flex w-max rounded-border-radius-md bg-primary-card Qsmd:bg-transparent Qsmd:pl-padding-md Qlg:pl-padding-base Qlg:px-padding-base ">
                        <SwitcherTabs
                          tabs={tabs}
                          initialActiveTab={selectedTab}
                          type="single"
                          swicherTabBgColor="var(--primary-card)"
                        />
                      </div>
                    </div>
                  </div>

                  {selectedTab === "User details" && (
                    <div className="flex flex-col Qlg:flex-row gap-gap-md max-w-tab-width-normal lg:mx-margin-base mx-margin-md">
                      <CommonDetailCard
                        cardTitle="Company Details"
                        numCols={GlobalConfiguration.lengthCheckOne}
                        variant="third"
                        entries={[
                          {
                            heading: "Entity ID",
                            content:
                              specificUserData?.employees?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.entity_id || "Not Given",
                            type: "text",
                          },
                          {
                            heading: "Entity name",
                            content:
                              specificUserData?.pan_details?.full_name ||
                              "Not Given",
                            type: "text",
                          },
                          {
                            heading: "Entity PAN number",
                            content:
                              specificUserData?.pan_details?.pan || "Not Given",
                            type: "text",
                          },
                        ]}
                      />

                      <CommonDetailCard
                        cardTitle="PAN Details"
                        numCols={GlobalConfiguration.lengthCheckOne}
                        variant="third"
                        entries={[
                          {
                            heading: "PAN number",
                            content:
                              specificUserData?.pan_details?.pan || "Not Given",
                            type: "text",
                            onClick:
                              specificUserData?.pan_details?.pan &&
                              services?.some(
                                (s) => s === "VPAN" || s === "Admin",
                              )
                                ? () => {
                                    if (
                                      payload.type ===
                                      "bene_account_detail_modal"
                                    ) {
                                      actionRestricted();
                                    } else {
                                      handlePANDetails(
                                        specificUserData?.pan_details?.pan,
                                      );
                                    }
                                  }
                                : undefined,
                            isDisabled: !(
                              specificUserData?.pan_details?.pan &&
                              services?.some(
                                (s) => s === "VPAN" || s === "Admin",
                              )
                            ),
                          },
                          {
                            heading: "Full name",
                            content:
                              specificUserData?.pan_details?.full_name ||
                              "Not Given",
                            type: "text",
                          },
                          {
                            heading: "Created on",
                            content: specificUserData?.pan_details?.created_on
                              ? formatDateViewAll(
                                  specificUserData?.pan_details?.created_on,
                                  true,
                                )
                              : "Not Given",
                            type: "text",
                          },
                          {
                            heading: "Last updated on",
                            content: specificUserData?.pan_details
                              ?.last_updated_on
                              ? formatDateViewAll(
                                  specificUserData?.pan_details
                                    ?.last_updated_on,
                                  true,
                                )
                              : "Not Given",
                            type: "text",
                          },
                        ]}
                      />

                      <CommonDetailCard
                        cardTitle="Origin Details"
                        numCols={GlobalConfiguration.lengthCheckOne}
                        variant="third"
                        entries={[
                          {
                            heading: "Created by",
                            content:
                              specificUserData?.employees?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.created_by_name || "Not Given",
                            type: "text",
                          },
                          {
                            heading: "Created on",
                            content: specificUserData?.employees?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.created_on
                              ? formatDateViewAll(
                                  specificUserData?.employees?.[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.created_on,
                                  true,
                                )
                              : "Not Given",
                            type: "text",
                          },
                        ]}
                      />
                    </div>
                  )}

                  {selectedTab === "CIN details" &&
                    (specificUserData?.cin_details ? (
                      <div className="flex flex-col lg:flex-row gap-gap-md mt-margin-md max-w-tab-width-normal">
                        <div className="lg:w-width-lg flex flex-col gap-gap-md lg:mx-margin-base md:mx-margin-md mx-margin-md">
                          <div className="bg-primary-card px-padding-md py-padding-md rounded-border-radius-md text-font-sm border-b border-Blue-3 text-text-secondary">
                            <h4 className="text-font-md font-sans mb-margin-md font-semibold">
                              CIN Details
                            </h4>

                            <div className="lg:flex lg:gap-gap-lg gap-gap-base">
                              <div className="flex-1">
                                {[
                                  {
                                    label: "CIN number",
                                    value:
                                      specificUserData?.cin_details?.cin_number,
                                  },
                                  {
                                    label: "Company name",
                                    value:
                                      specificUserData?.cin_details
                                        ?.company_name,
                                  },
                                  {
                                    label: "Class of company",
                                    value:
                                      specificUserData?.cin_details
                                        ?.company_class,
                                  },
                                  {
                                    label: "Company status",
                                    value:
                                      specificUserData?.cin_details
                                        ?.company_status,
                                  },
                                ].map((item, idx, arr) => (
                                  <div
                                    key={idx}
                                    className="mb-margin-sm"
                                  >
                                    <div className="text-text-primary font-normal text-font-sm">
                                      {item.value || "Not available"}
                                    </div>
                                    <div
                                      className={`text-text-secondary font-normal text-font-xs ${
                                        idx !==
                                        arr.length -
                                          GlobalConfiguration.lengthCheckOne
                                          ? "border-b border-Blue-3 pb-padding-sm"
                                          : "border-b border-Blue-3 pb-padding-sm lg:border-0 lg:pb-padding-base"
                                      }`}
                                    >
                                      {item.label}
                                    </div>
                                  </div>
                                ))}
                              </div>

                              <div className="hidden lg:block w-px bg-Blue-3" />
                              <div className="flex-1">
                                {[
                                  {
                                    label: "Listed status",
                                    value:
                                      specificUserData?.cin_details
                                        ?.listed_status,
                                  },
                                  {
                                    label: "Estd. on",
                                    value:
                                      specificUserData?.cin_details
                                        ?.incorporation_date,
                                    isDate: true,
                                  },
                                  {
                                    label: "Contact number",
                                    value:
                                      specificUserData?.cin_details
                                        ?.phone_number,
                                  },
                                  {
                                    label: "Email ID",
                                    value: specificUserData?.cin_details?.email,
                                  },
                                ].map((item, idx, arr) => (
                                  <div
                                    key={idx}
                                    className={`mb-margin-sm ${
                                      idx ===
                                      GlobalConfiguration.lengthCheckZero
                                        ? "pt-padding-base lg:pt-padding-base md:pt-padding-sm"
                                        : ""
                                    }`}
                                  >
                                    <div className="text-text-primary font-normal text-font-sm">
                                      {item.value
                                        ? item.isDate
                                          ? formatDateViewAll(item.value, true)
                                          : item.value
                                        : "Not available"}
                                    </div>
                                    <div
                                      className={`text-text-secondary font-normal text-font-xs ${
                                        idx !==
                                        arr.length -
                                          GlobalConfiguration.lengthCheckOne
                                          ? "border-b border-Blue-3 pb-padding-sm"
                                          : ""
                                      }`}
                                    >
                                      {item.label}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>

                          <div className="flex flex-col lg:flex-row gap-gap-md">
                            <div className="flex-1 bg-Blue-5 p-padding-md rounded-border-radius-md text-font-sm border-b border-Blue-3 text-text-secondary">
                              <h4 className="font-semibold pb-padding-md text-font-sm">
                                Annual Compliance Status
                              </h4>
                              <p className="text-text-primary">
                                {specificUserData?.cin_details?.last_agm_date
                                  ? formatDateViewAll(
                                      specificUserData?.cin_details
                                        ?.last_agm_date,
                                      true,
                                    )
                                  : "Not available"}
                              </p>
                              <p className="border-b border-Blue-3 pb-padding-sm">
                                Last AGM date
                              </p>

                              <p className="pt-padding-sm text-text-primary">
                                {specificUserData?.cin_details?.last_bs_date
                                  ? formatDateViewAll(
                                      specificUserData?.cin_details
                                        ?.last_bs_date,
                                      true,
                                    )
                                  : "Not available"}
                              </p>
                              <p>Last BS date</p>
                            </div>

                            <div className="flex-1 bg-Blue-5 p-padding-md rounded-border-radius-md text-font-sm border-b border-Blue-3 text-text-secondary">
                              <h4 className="font-semibold pb-padding-md text-font-sm">
                                Capital Details
                              </h4>
                              <p className="text-text-primary">
                                {specificUserData?.cin_details
                                  ?.paid_up_capital || "Not available"}
                              </p>
                              <p className="border-b border-Blue-3 pb-padding-sm">
                                Paid up capital
                              </p>
                              <p className="pt-padding-sm text-text-primary">
                                {specificUserData?.cin_details
                                  ?.authorized_capital || "Not available"}
                              </p>
                              <p>Authorized Capital</p>
                            </div>
                          </div>
                        </div>

                        <div className="lg:w-width-sm flex flex-col bg-Blue-5 text-text-secondary p-padding-md rounded-border-radius-md text-font-sm lg:self-stretch lg:mx-margin-base md:mx-margin-md mx-margin-md">
                          <article className="flex flex-col flex-grow h-height-full">
                            <span className="font-semibold text-font-sm text-text-secondary mb-margin-sm">
                              Address Details
                            </span>

                            <div className="flex flex-col flex-grow">
                              <span className="text-text-primary text-font-sm">
                                {specificUserData?.cin_details
                                  ?.present_address || "Not Given"}
                              </span>
                              <span className="text-text-secondary text-font-xs mb-margin-md">
                                Permanent address
                              </span>

                              <div className="flex-grow rounded-border-radius-md overflow-hidden w-width-full h-[200px]">
                                <GeoMapLeaflet
                                  address={
                                    specificUserData?.cin_details
                                      ?.present_address
                                  }
                                />
                              </div>
                            </div>
                          </article>
                        </div>
                      </div>
                    ) : (
                      <div className="flex flex-col lg:flex-row gap-gap-md mt-margin-md max-w-tab-width-normal mx-margin-md lg:mx-margin-base bg-primary-card rounded-border-radius-md">
                        <div className="p-padding-md w-width-full flex flex-col">
                          <span className="text-font-sm font-sans mb-margin-md text-text-primary font-semibold">
                            CIN details
                          </span>
                          <p className="text-font-sm font-sans text-text-secondary">
                            CIN details not available.
                          </p>
                        </div>
                      </div>
                    ))}

                  {selectedTab === "DIN details" && (
                    <>
                      {specificUserData?.din_details ? (
                        <div className="flex flex-col lg:flex-row gap-gap-md mt-margin-md max-w-tab-width-normal">
                          <div className="lg:w-width-lg flex flex-col gap-gap-md lg:mx-margin-base md:mx-margin-md mx-margin-md">
                            <div className="bg-primary-card px-padding-md py-padding-md rounded-border-radius-md text-font-sm text-text-secondary">
                              <h4 className="text-font-md font-sans mb-margin-md font-semibold">
                                DIN Details
                              </h4>

                              <div className="flex flex-col lg:flex-row lg:gap-gap-lg gap-gap-md">
                                <div className="flex-1">
                                  {[
                                    {
                                      label: "DIN number",
                                      value:
                                        specificUserData?.din_details
                                          ?.din_number,
                                    },
                                    {
                                      label: "Full name",
                                      value:
                                        specificUserData?.din_details
                                          ?.full_name,
                                    },
                                    {
                                      label: "Father’s name",
                                      value:
                                        specificUserData?.din_details
                                          ?.father_name,
                                    },
                                    {
                                      label: "Date of birth",
                                      value: specificUserData?.din_details?.dob
                                        ? formatDateViewAll(
                                            specificUserData?.din_details?.dob,
                                            true,
                                            true,
                                          )
                                        : null,
                                    },
                                  ].map((item, idx, arr) => (
                                    <div
                                      key={idx}
                                      className="mb-margin-sm"
                                    >
                                      <div className="text-text-primary font-normal text-font-sm">
                                        {item.value || "Not available"}
                                      </div>
                                      <div
                                        className={`text-text-secondary font-normal text-font-xs ${
                                          idx !==
                                          arr.length -
                                            GlobalConfiguration.lengthCheckOne
                                            ? "border-b border-Blue-3 pb-padding-sm"
                                            : "border-b border-Blue-3 pb-padding-sm lg:border-border-base lg:pb-padding-base"
                                        }`}
                                      >
                                        {item.label}
                                      </div>
                                    </div>
                                  ))}
                                </div>

                                <div className="hidden lg:block w-px bg-Blue-3" />

                                <div className="flex-1">
                                  {[
                                    {
                                      label: "Nationality",
                                      value:
                                        specificUserData?.din_details
                                          ?.nationality,
                                    },
                                    {
                                      label: "PAN number",
                                      value:
                                        specificUserData?.din_details
                                          ?.pan_number,
                                    },
                                    {
                                      label: "Email ID",
                                      value:
                                        specificUserData?.din_details?.email,
                                    },
                                    {
                                      label: "Last updated on",
                                      value: specificUserData?.din_details
                                        ?.last_updated_on
                                        ? formatDateViewAll(
                                            specificUserData?.din_details
                                              ?.last_updated_on,
                                            true,
                                            true,
                                          )
                                        : null,
                                    },
                                  ].map((item, idx, arr) => (
                                    <div
                                      key={idx}
                                      className="mb-margin-sm"
                                    >
                                      <div className="text-text-primary font-normal text-font-sm">
                                        {item.value || "Not available"}
                                      </div>
                                      <div
                                        className={`text-text-secondary font-normal text-font-xs ${
                                          idx !==
                                          arr.length -
                                            GlobalConfiguration.lengthCheckOne
                                            ? "border-b border-Blue-3 pb-padding-sm"
                                            : ""
                                        }`}
                                      >
                                        {item.label}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>

                          <section className="lg:w-width-sm flex flex-col bg-Blue-5 text-text-secondary p-padding-md rounded-border-radius-md text-font-sm lg:self-stretch lg:mx-margin-base md:mx-margin-md mx-margin-md">
                            <article className="flex flex-col flex-grow h-height-full">
                              <span className="font-semibold text-font-sm text-text-secondary mb-margin-sm">
                                Address Details
                              </span>

                              <div className="flex flex-col flex-grow">
                                <span className="text-text-primary text-font-sm">
                                  {specificUserData?.din_details
                                    ?.present_address || "Not Given"}
                                </span>
                                <span className="text-text-secondary text-font-xs mb-margin-md">
                                  Permanent address
                                </span>

                                <div className="flex-grow rounded-border-radius-md overflow-hidden w-width-full h-[200px] md:h-[170px]">
                                  <GeoMapLeaflet
                                    address={
                                      specificUserData?.din_details
                                        ?.present_address
                                    }
                                  />
                                </div>
                              </div>
                            </article>
                          </section>
                        </div>
                      ) : (
                        <div className="flex flex-col lg:flex-row gap-gap-md mt-margin-md max-w-tab-width-normal mx-margin-md lg:mx-margin-base bg-primary-card rounded-border-radius-md">
                          <div className="p-padding-md w-width-full flex flex-col">
                            <span className="text-font-sm font-sans mb-margin-md text-text-primary font-semibold">
                              DIN details
                            </span>
                            <p className="text-font-sm font-sans text-text-secondary">
                              DIN details not available
                            </p>
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  {selectedTab === "Roles" && (
                    <div className="flex flex-wrap gap-gap-md mx-margin-md lg:mx-margin-base">
                      {rolesMap &&
                      Object.keys(rolesMap).length >
                        GlobalConfiguration.lengthCheckZero ? (
                        Object.entries(rolesMap).flatMap(
                          ([roleDesc, roleNames]) =>
                            Array.isArray(roleNames) &&
                            roleNames.map((roleName, index) => (
                              <div
                                key={`${roleDesc}-${index}`}
                                className="Qsm:w-card-max-width w-full gap-gap-sm flex flex-col justify-center flex-shrink-0 bg-primary-card rounded-card_radius px-padding-sm py-padding-sm rounded-border-radius-md Qsm:rounded-border-radius-sm text-text-primary shadow-card"
                              >
                                <TitleSubtitlePair
                                  title={
                                    roleName
                                      ? roleName
                                          .charAt(
                                            GlobalConfiguration.lengthCheckZero,
                                          )
                                          .toUpperCase() +
                                        roleName
                                          .slice(
                                            GlobalConfiguration.lengthCheckOne,
                                          )
                                          .toLowerCase()
                                      : ""
                                  }
                                  subtitle="Role name"
                                  variant="sm"
                                  enableTicker
                                />
                                <TitleSubtitlePair
                                  variant="sm "
                                  title={
                                    roleDesc
                                      ? roleDesc
                                          .charAt(
                                            GlobalConfiguration.lengthCheckZero,
                                          )
                                          .toUpperCase() +
                                        roleDesc
                                          .slice(
                                            GlobalConfiguration.lengthCheckOne,
                                          )
                                          .toLowerCase()
                                      : ""
                                  }
                                  subtitle="Role description"
                                  enableTicker
                                />
                              </div>
                            )),
                        )
                      ) : (
                        <div className="flex flex-col lg:flex-row gap-gap-md w-full max-w-tab-width-normal mx-margin-md lg:mx-margin-base bg-primary-card rounded-border-radius-md">
                          <div className="p-padding-md w-width-full flex flex-col">
                            <span className="text-font-sm font-sans mb-margin-md text-text-primary font-semibold">
                              Roles
                            </span>
                            <p className="text-font-sm font-sans text-text-secondary">
                              No roles assigned
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {selectedTab === "Features" && (
                    <div className="flex flex-wrap gap-gap-md mx-margin-md lg:mx-margin-base">
                      {featuresMap &&
                      Object.keys(featuresMap).length >
                        GlobalConfiguration.lengthCheckZero ? (
                        Object.values(featuresMap)
                          ?.flat()
                          ?.map((feature, index) => (
                            <div
                              key={feature?.feature_id || index}
                              className="Qsm:w-card-max-width w-full gap-gap-sm flex flex-col justify-center flex-shrink-0 bg-primary-card rounded-card_radius px-padding-sm py-padding-sm rounded-border-radius-md Qsm:rounded-border-radius-sm text-text-primary shadow-card"
                            >
                              {/* Feature Name */}
                              <TitleSubtitlePair
                                title={
                                  feature?.feature_name
                                    ? feature.feature_name
                                        .charAt(
                                          GlobalConfiguration.lengthCheckZero,
                                        )
                                        .toUpperCase() +
                                      feature.feature_name
                                        .slice(
                                          GlobalConfiguration.lengthCheckOne,
                                        )
                                        .toLowerCase()
                                    : ""
                                }
                                subtitle="Feature name"
                                variant="sm"
                                enableTicker
                              />

                              {/* Feature Description */}
                              <TitleSubtitlePair
                                title={
                                  feature?.feature_description
                                    ? feature.feature_description
                                        .charAt(
                                          GlobalConfiguration.lengthCheckZero,
                                        )
                                        .toUpperCase() +
                                      feature.feature_description
                                        .slice(
                                          GlobalConfiguration.lengthCheckOne,
                                        )
                                        .toLowerCase()
                                    : ""
                                }
                                subtitle="Feature description"
                                variant="sm"
                                enableTicker
                              />
                            </div>
                          ))
                      ) : (
                        <div className="flex flex-col w-full lg:flex-row gap-gap-md mt-margin-md max-w-tab-width-normal mx-margin-md lg:mx-margin-base bg-primary-card rounded-border-radius-md">
                          <div className="p-padding-md w-width-full flex flex-col">
                            <span className="text-font-sm font-sans mb-margin-md text-text-primary font-semibold">
                              Features
                            </span>
                            <p className="text-font-sm font-sans text-text-secondary">
                              No features assigned
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {selectedTab === "Services" && (
                    <div>
                      {Object?.entries(servicesMap)?.length >
                      GlobalConfiguration.lengthCheckZero ? (
                        Object?.entries(servicesMap)?.map(
                          ([header, values]) => (
                            <div key={header}>
                              <div className="pr-padding-md pl-padding-md Qlg:pl-padding-base">
                                <h5 className="bg-primary-nav-act rounded-border-radius-md w-full font-semibold px-padding-md py-padding-sm text-text-primary">
                                  {toTitleCase(header)}
                                </h5>
                              </div>

                              <div className="flex flex-wrap gap-gap-md mx-margin-md lg:mx-margin-base my-margin-md">
                                {values.map((service, index) => (
                                  <div
                                    key={service?.service_id || index}
                                    className="Qsm:w-card-max-width w-full gap-gap-sm flex flex-col justify-center flex-shrink-0 bg-primary-card rounded-card_radius px-padding-sm py-padding-sm rounded-border-radius-md Qsm:rounded-border-radius-sm text-text-primary shadow-card"
                                  >
                                    {/* Service Name */}
                                    <TitleSubtitlePair
                                      title={
                                        service?.service_name
                                          ? service.service_name
                                              .charAt(
                                                GlobalConfiguration.lengthCheckZero,
                                              )
                                              .toUpperCase() +
                                            service.service_name
                                              .slice(
                                                GlobalConfiguration.lengthCheckOne,
                                              )
                                              .toLowerCase()
                                          : ""
                                      }
                                      subtitle="Service name"
                                      variant="sm"
                                      enableTicker
                                    />

                                    {/* Service Description */}
                                    <TitleSubtitlePair
                                      title={
                                        service?.service_desc
                                          ? service.service_desc
                                              .charAt(
                                                GlobalConfiguration.lengthCheckZero,
                                              )
                                              .toUpperCase() +
                                            service.service_desc
                                              .slice(
                                                GlobalConfiguration.lengthCheckOne,
                                              )
                                              .toLowerCase()
                                          : ""
                                      }
                                      subtitle="Service description"
                                      variant="sm"
                                      enableTicker
                                    />
                                  </div>
                                ))}
                              </div>
                            </div>
                          ),
                        )
                      ) : (
                        <div className="flex flex-col w-full lg:flex-row gap-gap-md mt-margin-md max-w-tab-width-normal mx-margin-md lg:mx-margin-base bg-primary-card rounded-border-radius-md">
                          <div className="p-padding-md w-width-full flex flex-col">
                            <span className="text-font-sm font-sans mb-margin-md text-text-primary font-semibold">
                              Services
                            </span>
                            <p className="text-font-sm font-sans text-text-secondary">
                              No services assigned
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {selectedTab === "Assigned Tags" && (
                    <CommonContainerCard
                      header="Tags"
                      subheader="These will be used to give access of owner accounts to the users who share even one of the assigned tags. "
                      iconIsDisabled={!isAdmin}
                      icon={
                        "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                      }
                      handleFunction={() => {
                        if (isAdmin) {
                          handleTagPopupOpen();
                        }
                      }}
                    >
                      <div className="flex flex-wrap gap-gap-sm">
                        {specificUserData?.employees?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.account_tags?.length >
                        GlobalConfiguration.lengthCheckZero ? (
                          specificUserData?.employees?.[
                            GlobalConfiguration.lengthCheckZero
                          ]?.account_tags?.map((tag) => (
                            <Chips
                              txtChip={tag}
                              enabledTextColor="var(--text-primary)"
                              enabledBgColor="var(--primary-nav)"
                            />
                          ))
                        ) : (
                          <p className="text-text-secondary text-font-sm">
                            No tags assigned to this account
                          </p>
                        )}
                      </div>
                    </CommonContainerCard>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default MyProfileDetails;
